import ItemD7 from './ItemD7';

export default ItemD7;

